import { FC, ReactNode } from 'react';
import { connect, useDispatch } from 'react-redux';
import { removeNotification, removeNotificationWithInfo } from '../../store/notifications/actions';
import Notification from './Notification';
import NotificationWithInfo from './NotificationWithInfo';
import { AppState } from '../../store/appState';
import { isNotificationInfo, NotificationsState } from '../../store/notifications/state';

interface Props {
    notificationContainer: NotificationsState;
}

const NotificationContainer: FC<Props> = props => {
    const { notificationContainer } = props;
    const dispatch = useDispatch();

    function onCloseNotification(id) {
        dispatch(removeNotification(id));
    }

    function onCloseNotificationWithInfo() {
        dispatch(removeNotificationWithInfo());
    }

    function onConfirmNotificationWithInfo() {
        const infoNotification = notificationContainer.info;

        if (infoNotification && isNotificationInfo(infoNotification)) {
            infoNotification.callback?.(infoNotification?.dataRaw);
        }

        dispatch(removeNotificationWithInfo());
    }

    let notification: ReactNode;
    if (notificationContainer.info) {
        //Todo: isCustom should be possible to remove through a type-guard
        if (isNotificationInfo(notificationContainer.info)) {
            notification = (
                <NotificationWithInfo
                    infoNotification={notificationContainer.info}
                    onClose={onCloseNotificationWithInfo}
                    onConfirm={onConfirmNotificationWithInfo}
                />
            );
        }
    }

    return (
        <>
            <Notification notifications={notificationContainer.sysa} onClose={onCloseNotification} />
            {notification}
        </>
    );
};

const mapStateToProps = (state: AppState): Props => {
    return {
        notificationContainer: state.notifications
    };
};

export default connect(mapStateToProps)(NotificationContainer);
